export default __webpack_public_path__ + "static/media/airport_100px.d533a11e.svg";